import requests from "./httpService";

const CashBookPrintServices = {
  getPassbooksByStore: (storeId) =>
    requests.get(
      `/site-cash-passbooks/by-store?storeId=${encodeURIComponent(
        storeId
      )}`
    )
};

export default CashBookPrintServices;